

import axios, { AxiosRequestConfig } from 'axios';
import { mockHomeworkRequest } from '@/utils/homeworkSession';
import { teacherPracticePost } from '@/utils/teacherPracticeTransport';

export interface AxiosResponseType<T = never> {
  code: number;
  data: T;
  msg: string;
  header?: { [key: string]: string; };
}

export async function post<T>(url: string, data = {}, config?: AxiosRequestConfig): Promise<AxiosResponseType<T>> {
  const scoped = mockHomeworkRequest(url, data);
  if (scoped?.url.startsWith('/api/workspace/practice/teacher/')) {
    return teacherPracticePost<T>(scoped.url.slice('/api/workspace/practice/teacher/'.length), scoped.body, scoped.token);
  }
  if (scoped) { url = scoped.url; data = scoped.body; }
  const { ...restConfig } = config || {};
  if (scoped) restConfig.headers = { ...restConfig.headers, 'X-Homework-Session': scoped.token };

  return new Promise<AxiosResponseType<T>>((resolve, reject) => {
    axios.post<any, AxiosResponseType<T>, any>(url, data, restConfig).then((res) => {
      const body = res as unknown as AxiosResponseType<T>;
      if (body.code !== 200) {
        reject({
          ...body,
          msg: body.msg,
          message: body.msg,
        });
        return;
      }
      resolve(body);
    }).catch(e => {
      console.error('[Request Error]', scoped || url.startsWith('/api/practice/') ? { message: '作业请求失败', code: e?.code } : e);

      reject(e);
    });
  });
}
